export default "data:image/gif;base64,R0lGODlhEgAMAPEBAAAAi/////8AAAAAACH5BAAAAAAALAAAAAASAAwAAAIclI+pyxgfmouGticVPtFqL4DJVoUSmXFQyrZLAQA7"